import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IonicModule } from '@ionic/angular/lazy';
import { TranslateModule } from '@ngx-translate/core';
import { AbstractComponentMobile } from '../../abstract/abstract-component-global.directive';
import { SolarPanelProduction } from '../../models/solar-panel-production.model';
import { DeviceTypeLabelComponent } from '../device-type-label/device-type-label.component';
import { FadingSpanComponent } from '../fading-span/fading-span.component';
import { HistoryData } from '../../models/history-client.model';

@Component({
    selector: 'web-panels-production',
    templateUrl: './panels-production.component.html',
    styleUrls: ['./panels-production.component.scss'],
    imports: [IonicModule, FadingSpanComponent, DeviceTypeLabelComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelsProductionComponent extends AbstractComponentMobile {
    public override tag = '[PanelsProductionComponent]';

    solarPanelsData = input<SolarPanelProduction[]>([]);

    consomptionData = input<HistoryData>({} as HistoryData);

    currentUnit = input<string>('');

    toBatteryTotal = input(0);

    activeIndex = input(-1);

    solarPanels = computed(() => {
        return this.activeIndex() === -1 ? this.solarPanelsData() : [this.solarPanelsData()[this.activeIndex()]];
    });

    toBattery = computed(() => {
        if (this.activeIndex() === -1) {
            return this.toBatteryTotal();
        }
        const panelData = this.solarPanelsData()[this.activeIndex()];
        return panelData?.totalValues?.totalProd?.wattValueSuffix?.value > 0
            ? Math.ceil(
                  (panelData.totalValues.totalConso.wattValueSuffix.value /
                      panelData.totalValues.totalProd.wattValueSuffix.value) *
                      100,
              )
            : 0;
    });
}
